export const state = {
  app: 'user',
  config: {
    contents: {},
    extensions: {},
    style: {},
  },
  isOnSite: false,
  layout: 'div',
  errors: [],
  cstm: null,
  language: 'de-DU',
  device: 'desktop',
  apiResponse: null,
  loading: true,
  isLoggedIn: false,
  feedbackRequested: false,
  feedbackSeen: false,
  needProfileInput: true,
  activeProfile: null,
  profiles: [],
  showSide: false,
  showNav: false,
  showOverlay: true,
  showProgress: true,
  showVideoArchive: true,

  userData: {},
  dataProtectionStatement: {},
  showDataProtectionModal: false,

  videoModule: null,
  moduleContainers: [],
  modules: [],
  finishedModules: [],

  activeModule: null,
  activeModuleContainer: null,
  sessionURL: null,

  progress: {},

  resultPDFSource: null,
  projectVariables: null,
  variables: null,
  appearance: {
    overlay: false,
    logo: '',
    showProgress: true,
  },
  videos: [],
  texts: {},

  reportBindings: [],
  componentNameMap: {},
  passwordRequirements: {},
  inTransition: false,
};
